import React from 'react';

const Clock = () => {
    return (
        <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.50002 16.4167C12.412 16.4167 15.5834 13.2453 15.5834 9.33333C15.5834 5.42132 12.412 2.25 8.50002 2.25C4.588 2.25 1.41669 5.42132 1.41669 9.33333C1.41669 13.2453 4.588 16.4167 8.50002 16.4167Z" stroke="#00A7B5" strokeWidth="1.13333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.5 5.08334V9.33334L11.3333 10.75" stroke="#00A7B5" strokeWidth="1.13333" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default Clock;
